module.exports = __webpack_public_path__ + "static/media/Residential_47.ac8a0bde.jpg";